/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MeetingsInputs */

const th_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การประชุม`)
};

const en_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meetings`)
};

const ja_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミーティング`)
};

const zh_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会议`)
};

const es_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reuniones`)
};

const pt_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reuniões`)
};

const id_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertemuan`)
};

const fr_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réunions`)
};

const tl_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga miting`)
};

const vi_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuộc họp`)
};

const ko_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`회의`)
};

const de_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meetings`)
};

const ru_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встречи`)
};

const tr_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toplantılar`)
};

const it_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riunioni`)
};

const pl_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spotkania`)
};

const uk_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зустрічі`)
};

const hi_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैठकें`)
};

const ar_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاجتماعات`)
};

const ms_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesyuarat`)
};

const bn_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সভা`)
};

const zh_tw2_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`會議`)
};

const zh_hk2_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`會議`)
};

const ur_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملاقاتیں`)
};

const fa_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جلسات`)
};

const sw_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikutano`)
};

const nl_meetings = /** @type {(inputs: MeetingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesprekken`)
};

/**
* | output |
* | --- |
* | "Meetings" |
*
* @param {MeetingsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meetings = /** @type {((inputs?: MeetingsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MeetingsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meetings(inputs)
	if (locale === "ja") return ja_meetings(inputs)
	if (locale === "zh") return zh_meetings(inputs)
	if (locale === "es") return es_meetings(inputs)
	if (locale === "pt") return pt_meetings(inputs)
	if (locale === "id") return id_meetings(inputs)
	if (locale === "fr") return fr_meetings(inputs)
	if (locale === "tl") return tl_meetings(inputs)
	if (locale === "vi") return vi_meetings(inputs)
	if (locale === "ko") return ko_meetings(inputs)
	if (locale === "de") return de_meetings(inputs)
	if (locale === "ru") return ru_meetings(inputs)
	if (locale === "tr") return tr_meetings(inputs)
	if (locale === "it") return it_meetings(inputs)
	if (locale === "pl") return pl_meetings(inputs)
	if (locale === "uk") return uk_meetings(inputs)
	if (locale === "hi") return hi_meetings(inputs)
	if (locale === "ar") return ar_meetings(inputs)
	if (locale === "ms") return ms_meetings(inputs)
	if (locale === "bn") return bn_meetings(inputs)
	if (locale === "zh-TW") return zh_tw2_meetings(inputs)
	if (locale === "zh-HK") return zh_hk2_meetings(inputs)
	if (locale === "ur") return ur_meetings(inputs)
	if (locale === "fa") return fa_meetings(inputs)
	if (locale === "sw") return sw_meetings(inputs)
	if (locale === "nl") return nl_meetings(inputs)
	return en_meetings(inputs)
});